/**
 * Determine if the argument is an Observable
 */
import { from as fromPromise, Observable } from 'rxjs';
import { isPromise } from 'src/util/promise';

export function isObservable(obj: any | Observable<any>): obj is Observable<any> {
  // Copy/pasted from https://raw.githubusercontent.com/angular/angular/3f331b53b2d13671c3585a57fd228cc263d4b8d1/packages/core/src/util/lang.ts
  // TODO use Symbol.observable when https://github.com/ReactiveX/rxjs/issues/2415 will be resolved
  return obj != null && typeof obj.subscribe === 'function';
}

export function toObservable(r: any): Observable<any> {
  const obs = isPromise(r) ? fromPromise(r) : r;
  if (!isObservable(obs)) {
    throw new Error(`Expected validator to return Promise or Observable.`);
  }
  return obs;
}
